import "../../../FhSelectField.css";
import { openBlock, createElementBlock, mergeProps, renderSlot } from "vue";
import { _ as _export_sfc } from "../../../_plugin-vue_export-helper-1tPrXgE0.js";
const _sfc_main = {};
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("select", mergeProps({ class: "fh-select-field" }, _ctx.$attrs), [
    renderSlot(_ctx.$slots, "default", {}, void 0, true)
  ], 16);
}
const FhSelectField = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-c018e7d2"]]);
export {
  FhSelectField as default
};
//# sourceMappingURL=FhSelectField.mjs.map
